import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AUTH_TOKEN, REFRESH_TOKEN, getFromLocalStorage } from 'utils/localStorage';

import {
  AuthInfo,
  SetAuthInfoData,
  ConfirmBirthdateData,
  LoginData,
  TokenLoginData,
  PasswordRecoveryData,
  PasswordRecoveryResponseData,
  PasswordUpdateData,
  RefreshTokenData,
  ConfirmPhoneData,
  ResendSmsData,
  LoginResponseData,
} from 'types';
import { promiseActionFactory } from '@teroneko/redux-saga-promise';

export const loginAction = promiseActionFactory<LoginResponseData>().create<LoginData>('auth/login');
export const tokenLoginAction = promiseActionFactory<AuthInfo>().create<TokenLoginData>('auth/tokenLogin');
export const confirmPhoneAction = promiseActionFactory<AuthInfo>().create<ConfirmPhoneData>('auth/confirmPhone');
export const logoutAction = promiseActionFactory().create('auth/logout');
export const refreshTokenAction = promiseActionFactory().create<RefreshTokenData>('auth/refreshToken');
export const recoverPasswordAction = promiseActionFactory<PasswordRecoveryResponseData>().create<PasswordRecoveryData>('auth/recoverPassword');
export const resendSmsAction = promiseActionFactory<PasswordRecoveryResponseData>().create<ResendSmsData>('auth/resendSms');
export const resetPasswordAction = promiseActionFactory().create<PasswordUpdateData>('auth/resetPassword');
export const confirmBirthdateAction = promiseActionFactory().create<ConfirmBirthdateData>('auth/confirmBirthdate');

const initialState: AuthInfo = {
  token: getFromLocalStorage(AUTH_TOKEN),
  refreshToken: getFromLocalStorage(REFRESH_TOKEN),
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthInfo: (state, action: PayloadAction<SetAuthInfoData>) => {
      return { ...state, ...action.payload.data };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(logoutAction, (state) => ({
        token: '',
        refreshToken: ''
      }));
  }
});

export default authSlice.reducer;

export const { setAuthInfo } = authSlice.actions;
